import { render, staticRenderFns } from "./MessageForwarder.vue?vue&type=template&id=d3d6075c&scoped=true"
import script from "./MessageForwarder.vue?vue&type=script&lang=js"
export * from "./MessageForwarder.vue?vue&type=script&lang=js"
import style0 from "./MessageForwarder.vue?vue&type=style&index=0&id=d3d6075c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d6075c",
  null
  
)

export default component.exports